import { gql } from "@apollo/client";

export const REASON_FOR_VISIT_V2 = gql`
  query getReasonsForVisitV2 {
    getReasonsForVisitV2 {
      items {
        name,
        type,
        options,
      },
      messages,
    }
  }
`;
